import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FaFacebookF, FaInstagram, FaLinkedinIn, FaYoutube, FaApple, FaGooglePlay } from 'react-icons/fa';
import { FaXTwitter } from 'react-icons/fa6';
import { MdEmail, MdPhone, MdLocationOn, MdArrowForward } from 'react-icons/md';
import { useToast } from './ToastProvider';
import pointfinityLogo from '../assets/pointfinity-logo-mark.png';
import './Footer.css';

const appStoreUrl = '#';
const playStoreUrl = '#';

const socials = [
  { icon: <FaFacebookF />, href: '#', label: 'Facebook', color: '#1877f2' },
  { icon: <FaInstagram />, href: '#', label: 'Instagram', color: '#e1306c' },
  { icon: <FaLinkedinIn />, href: '#', label: 'LinkedIn', color: '#0077b5' },
  { icon: <FaXTwitter />, href: '#', label: 'Twitter/X', color: '#fff' },
  { icon: <FaYoutube />, href: '#', label: 'YouTube', color: '#ff0000' },
];

const quickLinks = [
  { label: 'Home', to: '/' },
  { label: 'Features', href: '/#features' },
  { label: 'Subscription', href: '/#subscription' },
  { label: 'How It Works', href: '/#how-it-works' },
  { label: 'Download App', to: '/download' },
  { label: 'Contact Us', to: '/contact' },
];

const legalLinks = [
  { label: 'Terms & Conditions', to: '/terms' },
  { label: 'Privacy Policy', to: '/privacy' },
  { label: 'Store Owner Terms', to: '/store-owner-terms' },
  { label: 'Customer Terms', to: '/customer-terms' },
];

export default function Footer() {
  const year = new Date().getFullYear();
  const toast = useToast();
  const [email, setEmail] = useState('');

  const handleSubscribe = (e) => {
    e.preventDefault();
    if (!email) {
      toast({ message: 'Please enter your email address.', type: 'warning' });
      return;
    }
    toast({ message: `Subscribed successfully! Welcome to Pointfinity updates.`, type: 'success' });
    setEmail('');
  };

  return (
    <footer className="footer">
      {/* Top wave */}
      <div className="footer__wave">
        <svg viewBox="0 0 1440 60" preserveAspectRatio="none">
        </svg>
      </div>

      <div className="footer__body">
        

        <div className="footer__divider container" />

        {/* Main grid */}
        <div className="container footer__grid">
          {/* Brand col */}
          <div className="footer__brand">
            <Link to="/" className="footer__logo">
              <img src={pointfinityLogo} alt="Pointfinity logo" className="footer__logo-mark" />
              <span>Pointfinity</span>
            </Link>
            <p>A powerful multi-store loyalty & rewards platform helping businesses reward customers and grow repeat sales.</p>

            {/* App download mini buttons */}
            <div className="footer__apps">
              <a href={appStoreUrl} className="footer__app-btn" aria-label="App Store" onClick={(e) => { e.preventDefault(); toast({ message: 'App Store link coming soon!', type: 'info' }); }}>
                <FaApple /> App Store
              </a>
              <a href={playStoreUrl} className="footer__app-btn" aria-label="Google Play" onClick={(e) => { e.preventDefault(); toast({ message: 'Google Play link coming soon!', type: 'info' }); }}>
                <FaGooglePlay /> Google Play
              </a>
            </div>

            {/* Socials */}
            <div className="footer__socials">
              {socials.map((s) => (
                <a key={s.label} href={s.href} aria-label={s.label} className="footer__social-btn" style={{ '--hover-color': s.color }}>
                  {s.icon}
                </a>
              ))}
            </div>
          </div>

          {/* Quick links */}
          <div className="footer__col">
            <h4>Quick Links</h4>
            <ul>
              {quickLinks.map((l) => (
                <li key={l.label}>
                  {l.to
                    ? <Link to={l.to}><MdArrowForward className="link-arrow" />{l.label}</Link>
                    : <a href={l.href}><MdArrowForward className="link-arrow" />{l.label}</a>
                  }
                </li>
              ))}
            </ul>
          </div>

          {/* Legal */}
          <div className="footer__col">
            <h4>Legal</h4>
            <ul>
              {legalLinks.map((l) => (
                <li key={l.label}>
                  <Link to={l.to}><MdArrowForward className="link-arrow" />{l.label}</Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div className="footer__col">
            <h4>Contact Us</h4>
            <ul className="footer__contact-list">
              <li>
                <span className="footer__contact-icon"><MdEmail /></span>
                <div>
                  <span>Email</span>
                  <a href="mailto:support@pointfinity.com">support@pointfinity.com</a>
                </div>
              </li>
              <li>
                <span className="footer__contact-icon"><MdPhone /></span>
                <div>
                  <span>Phone</span>
                  <a href="tel:+1234567890">+1 (234) 567-890</a>
                </div>
              </li>
              <li>
                <span className="footer__contact-icon"><MdLocationOn /></span>
                <div>
                  <span>Address</span>
                  <p>123 Business Ave, Suite 100,<br />New York, NY 10001</p>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="footer__bottom">
        <div className="container footer__bottom-inner">
          <p>&copy; {year} Pointfinity. All rights reserved.</p>
          <div className="footer__bottom-links">
            <Link to="/terms">Terms</Link>
            <Link to="/privacy">Privacy</Link>
            <Link to="/contact">Contact</Link>
          </div>
          <p className="footer__made">Made with ❤️ for store owners</p>
        </div>
      </div>
    </footer>
  );
}
